import React from 'react';
import './Ticket.css';

const DEFAULT_EVENT_SETTINGS = {
  eventName: 'Old Skool Hangout',
  eventDate: 'December 15, 2025',
  eventTime: '6:00 PM - 11:00 PM',
  eventLocation: 'Kanu Ndubisi park, Mobolaji Johnson Ikeja'
};

function Ticket({ ticketData, qrCodeDataUrl, eventSettings = DEFAULT_EVENT_SETTINGS }) {
  if (!ticketData) {
    return null;
  }

  const {
    eventName = DEFAULT_EVENT_SETTINGS.eventName,
    eventDate = DEFAULT_EVENT_SETTINGS.eventDate,
    eventTime = DEFAULT_EVENT_SETTINGS.eventTime,
    eventLocation = DEFAULT_EVENT_SETTINGS.eventLocation
  } = eventSettings || {};

  return (
    <div className="ticket-container">
      <div className="ticket">
        {/* Ticket Header with Logo */}
        <div className="ticket-header">
          <div className="ticket-logo">
            <img src="/event-logo.jpeg" alt="Event Logo" className="ticket-logo-image" />
          </div>
          <div className="ticket-header-text">
            <h1 className="ticket-event-name">MTU Alumni Association</h1>
            <h2 className="ticket-event-title">{eventName}</h2>
          </div>
        </div>

        {/* Ticket Body */}
        <div className="ticket-body">
          {/* Left Section - Event Details */}
          <div className="ticket-details">
            <div className="ticket-detail-item">
              <div className="ticket-detail-icon">
                <CalendarIcon />
              </div>
              <div className="ticket-detail-info">
                <span className="ticket-detail-label">Date</span>
                <span className="ticket-detail-value">{eventDate}</span>
              </div>
            </div>

            <div className="ticket-detail-item">
              <div className="ticket-detail-icon">
                <ClockIcon />
              </div>
              <div className="ticket-detail-info">
                <span className="ticket-detail-label">Time</span>
                <span className="ticket-detail-value">{eventTime}</span>
              </div>
            </div>

            <div className="ticket-detail-item">
              <div className="ticket-detail-icon">
                <LocationIcon />
              </div>
              <div className="ticket-detail-info">
                <span className="ticket-detail-label">Venue</span>
                <span className="ticket-detail-value">{eventLocation}</span>
              </div>
            </div>

            <div className="ticket-detail-item">
              <div className="ticket-detail-icon">
                <UserIcon />
              </div>
              <div className="ticket-detail-info">
                <span className="ticket-detail-label">Attendee</span>
                <span className="ticket-detail-value">{ticketData.userName || ticketData.userEmail}</span>
              </div>
            </div>
          </div>

          {/* Right Section - QR Code */}
          <div className="ticket-codes">
            {/* Ticket ID */}
            <div className="ticket-id-section">
              <span className="ticket-id-label">Ticket ID</span>
              <span className="ticket-id-value">{ticketData.ticketId}</span>
            </div>

            {/* QR Code */}
            <div className="ticket-qr-section">
              <div className="ticket-qr-label">Scan QR Code</div>
              {qrCodeDataUrl && (
                <img 
                  src={qrCodeDataUrl} 
                  alt="QR Code" 
                  className="ticket-qr-code"
                />
              )}
            </div>
          </div>
        </div>

        {/* Ticket Footer */}
        <div className="ticket-footer">
          <p className="ticket-footer-text">
            Please present this ticket at the event entrance. Keep this ticket safe.
          </p>
          <div className="ticket-footer-logo">
            <span>MTU Alumni Association</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// Icon Components
const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M2 2H4V0H6V2H14V0H16V2H18C19.1 2 20 2.9 20 4V18C20 19.1 19.1 20 18 20H2C0.9 20 0 19.1 0 18V4C0 2.9 0.9 2 2 2ZM18 18V8H2V18H18ZM2 6H18V4H2V6Z" fill="currentColor"/>
  </svg>
);

const ClockIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10.5 5H9V11L14.25 14.15L15 12.92L10.5 10.25V5Z" fill="currentColor"/>
  </svg>
);

const LocationIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 10 20 10 20C10 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 11C8.9 11 8 10.1 8 9C8 7.9 8.9 7 10 7C11.1 7 12 7.9 12 9C12 10.1 11.1 11 10 11Z" fill="currentColor"/>
  </svg>
);

const UserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 3C11.66 3 13 4.34 13 6C13 7.66 11.66 9 10 9C8.34 9 7 7.66 7 6C7 4.34 8.34 3 10 3ZM10 17.2C7.5 17.2 5.29 15.92 4 13.98C4.03 11.99 8 10.9 10 10.9C11.99 10.9 15.97 11.99 16 13.98C14.71 15.92 12.5 17.2 10 17.2Z" fill="currentColor"/>
  </svg>
);

export default Ticket;

